import { createFileRoute, redirect } from '@tanstack/react-router'
import { KnowledgeBaseView } from '@/components/knowledge/KnowledgeBaseView'
import { knowledgeBaseKbIdSearch } from '@/components/knowledge/knowledgeBaseRouteSearch'

export type KnowledgeBaseIndexSearch = {
  openKb?: string
}

export const Route = createFileRoute('/_app/knowledge-base/')({
  validateSearch: (search: Record<string, unknown>): KnowledgeBaseIndexSearch => ({
    openKb:
      typeof search.openKb === 'string' && search.openKb.length > 0
        ? search.openKb
        : undefined,
  }),
  beforeLoad: ({ search }) => {
    if (search.openKb) {
      throw redirect({
        to: '/knowledge-base/$kbId',
        params: { kbId: search.openKb },
        search: knowledgeBaseKbIdSearch(),
        replace: true,
      })
    }
  },
  component: KnowledgeBaseListRoute,
})

function KnowledgeBaseListRoute() {
  return <KnowledgeBaseView />
}
